import { configureStore, Action } from "@reduxjs/toolkit";
import rootReducer, { RootStateInterface } from "./Reducers";
import { ThunkAction } from "redux-thunk";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";

const store = configureStore({
    devTools: process.env.NODE_ENV !== "production",
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }),
});

/**
 * Add reducer to Hot Module Replacement
 */
if (process.env.NODE_ENV === "development") {
    if ((module as any).hot) {
        (module as any).hot.accept("./Reducers", () => {
            store.replaceReducer(rootReducer);
        });
    }
}
export type StoreDispatch = typeof store.dispatch;

export type RootStateType = RootStateInterface;

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootStateType,
    undefined,
    Action<string>
>;

export const useAppDispatch = () => useDispatch<StoreDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
export const MainSelector: TypedUseSelectorHook<RootStateType> = useSelector;

export interface IStore extends RootStateInterface {}

export default store;
